module.exports = __webpack_public_path__ + "static/media/rs.192092d6.svg";